// extracted by mini-css-extract-plugin
export default {"singleAdElementContainer":"AdminAdElement_singleAdElementContainer__5zu5Q"};